import moment from 'moment'

export function isSuperAvaliado(emp) {
  if (!emp) return false
  if (!emp.mediaAvaliacoes || !emp.quantidadeAvaliacoes) return false
  if (emp.mediaAvaliacoes === 0 || emp.quantidadeAvaliacoes === 0) return false
  if (emp.mediaAvaliacoes === null || emp.quantidadeAvaliacoes === null) return false
  if (emp.mediaAvaliacoes === undefined || emp.quantidadeAvaliacoes === undefined) return false

  return parseFloat(emp.mediaAvaliacoes.toFixed(1)) >= 4.5 && emp.quantidadeAvaliacoes >= 20
}

export function getFutureDates(arrayDias) {
  const maxDays = 21

  const lastDay = arrayDias[arrayDias.length - 1]
  const futureDates = []
  for (let i = 1; i <= maxDays; i++) {
    futureDates.push(lastDay.clone().add(i, 'days'))
  }
  arrayDias.push(...futureDates)
  return arrayDias
}

export function getSportNames(categoriasEsporte) {
  return categoriasEsporte?.map((esporte, index) =>
    categoriasEsporte.length - 2 === index ? esporte.nome + ' e ' : categoriasEsporte.length - 1 === index ? esporte.nome : esporte.nome + ', ',
  )
}

export function daysFromToday(dia) {
  const selectedDay = moment(dia).startOf('day')
  const today = moment().startOf('day')
  return selectedDay.diff(today, 'days')
}
